module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kwoKi"))).then(() => parcelRequire('hEqeo'));